import { useTranslation } from 'react-i18next';

const LEGEND_MAX = 5;

export interface LegendEntry {
  key: string;
  label: string;
  color: string;
}

interface ChartLegendProps {
  entries: LegendEntry[];
  hiddenSeries?: Set<string>;
  hoveredKey: string | null;
  onHover: (key: string | null) => void;
}

export const ChartLegend = ({ entries, hiddenSeries, hoveredKey, onHover }: ChartLegendProps) => {
  const { t } = useTranslation('authenticated.reports');
  const visible = entries.slice(0, LEGEND_MAX);
  const overflow = entries.length - LEGEND_MAX;

  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 px-2 pb-1 pt-2">
      {visible.map(entry => {
        const hidden = hiddenSeries?.has(entry.key) ?? false;
        return (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <div
            key={entry.key}
            className="flex cursor-default items-center gap-1.5"
            style={{
              opacity: hidden ? 0.25 : hoveredKey !== null && hoveredKey !== entry.key ? 0.4 : 1,
              transition: 'opacity 150ms',
            }}
            onMouseEnter={() => onHover(entry.key)}
            onMouseLeave={() => onHover(null)}
          >
            <span
              className="h-2 w-2 shrink-0 rounded-sm"
              style={{ backgroundColor: entry.color }}
            />
            <span className="max-w-[96px] truncate text-xs text-muted-foreground">
              {entry.label}
            </span>
          </div>
        );
      })}
      {overflow > 0 && (
        <span className="text-xs text-muted-foreground">
          {t('common.overflowMore', { count: overflow })}
        </span>
      )}
    </div>
  );
};
